module.exports = __webpack_public_path__ + "static/media/about.d3a48979.webp";